import { PaymentIntent } from '@stripe/stripe-js';

import { IStation, ITariff } from '../station/types';
import { ICharge } from '../types';

export enum GuestTransactionStatus {
    PaymentPending = 'payment-pending',
    StartPending = 'start-pending',
    Starting = 'starting',
    Charging = 'charging',
    Finishing = 'finishing',
    Completed = 'completed',
    Canceled = 'canceled',
    RefundPending = 'refund-pending',
    Refunded = 'refunded',
    PaymentFailed = 'payment-failed',
}

export type PaymentIntentWithStripeAccount = PaymentIntent & { stripeAccount?: string };

export interface IPricing extends ITariff {
    currency: string;
    activationFee?: number;
}

export interface ITransaction {
    currency: string;
    archived: boolean;
    paymentStatus: string;
    _id: string;
    __id: number;
    station: IStation;
    connectorId: number;
    energy?: number;
    duration?: number;
    startAttempts: number;
    priceKW: number;
    priceTotal: number;
    chargingPrice: number;
    language: string;
    phone: string;
    email?: string;
    date: string;
    business: IGuestBusiness;
    transaction: ICharge;
    paymentIntent: PaymentIntentWithStripeAccount;
    status: GuestTransactionStatus;
    pricing: IPricing;
    idleCalcAt?: Date;
    idleStart?: Date;
    idleStop?: Date;
    idleFeeCalc: {
        isActive: boolean;
        timestamp: number | string;
        now: number | string;
        minutes: number;
        price: number;
        minutesPaid: number;
        minutesTotal: number;
        minutesGrace: number;
        minutesGraceLeft: number;
    };
    idleDuration: number;
    idlePrice: number;
    initialPaymentIntentAmount?: number;
    estimation?: {
        completionAt: string;
        minutesLeft: number;
    };
}

export interface IGuestBusiness {
    name: string;
    site: string;
    currency: string;
}

export interface ICreateTransactionRequest {
    connectorId: number;
    energy?: number;
    time?: number;
    language: string;
    phone: string;
    stationId: string;
    email?: string;
    disableSessionLimit?: boolean;
}

export interface IUpdateTransactionContactsRequest extends Pick<ICreateTransactionRequest, 'phone' | 'email'> {
    transactionId: string;
}

export enum EPaymentProvider {
    STRIPE = 'STRIPE',
}

export interface IPaymentType<Provider> {
    provider: EPaymentProvider;
    content: Provider;
}

export interface ILiqPay {
    request: ILiqPayRequest;
}

export interface ILiqPayRequest {
    data: string;
    signature: string;
}

export interface IIoka {
    request: IIokaRequest;
}

export interface IIokaRequest {
    order: IIokaOrder;
    order_access_token: string;
}

export interface IIokaOrder {
    id: string;
}
